import { getExtensionIcon } from './icons.js'

export interface FileTypeIconProps {
  extension: string
  className?: string
}

export const FileTypeIcon = ({ extension, className }: FileTypeIconProps) => {
  const IconComponent = getExtensionIcon(extension)

  return <IconComponent className={className} />
}
